import { createStyles, makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import { ErrorMessage } from 'src/components/ErrorMessage';
import { FlagsContext } from 'src/context';
import { AlertCircleIcon } from '../../Icons';
import { Body } from 'copilot-design-system';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      minHeight: 1,
      marginBottom: 20,
    },
  }),
);
/**
 * This component is used to wrap the error callout
 * with a fixed height to avoid the form jumping.
 * @returns {JSX.Element} Returns the error callout
 */
export const OnboardingFormError: React.FC<{
  errorText: string;
}> = ({ errorText }) => {
  const { EnableInputErrorIcon } = useContext(FlagsContext);
  const classNames = useStyles();
  return (
    <div className={classNames.root}>
      {errorText &&
        (EnableInputErrorIcon ? (
          <ErrorMessage message={errorText} />
        ) : (
          <div className="flex items-center gap-2 text-red">
            <AlertCircleIcon style={{ fontSize: 14 }} />
            <Body size="sm">{errorText}</Body>
          </div>
        ))}
    </div>
  );
};
